/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ResolvePendingDmResponse = zod.object({
  match: zod
    .object({
      invitationId: zod.uuid().describe("The open invitation's Core ledger id on that thread"),
      reachThreadId: zod
        .uuid()
        .describe(
          'The existing solo thread to re-open (the caller already has an open invitation to this identifier on it) — call the SDK to open it rather than minting a second thread',
        ),
    })
    .nullable()
    .describe(
      "The caller's own open dm-intent invitation to this identifier, or null when they have none — absent-shaped, so proceed to open a new thread and issue an invitation. Sender-scoped: never reveals anyone else's invitations.",
    ),
});

export type ResolvePendingDmResponse = zod.input<typeof ResolvePendingDmResponse>;
export type ResolvePendingDmResponseOutput = zod.output<typeof ResolvePendingDmResponse>;
